// The import card in the platform agent's panel (D12): before a menu import or a copy runs, while it runs, and how it
// ended. Wording from the Amigo for menus design's copy sheet (Import card, Not live yet, Buttons, Importing, Failed,
// What to try, the 5 reasons, Went live, Import done).
export default {
  title: {
    import: 'Importa il menu da {{platform}}',
    copy: 'Copia il menu da {{restaurant}}',
    data: 'Crea il menu che Amigo ha letto',
  },
  // A menu Amigo read from a file or the chat (QA36): a change card with each dish, before it is created.
  contents: {
    title: 'Crea {{categories}} e {{dishes}}',
    from: {
      file: 'Amigo ha letto questo dal tuo file',
      chat: 'Amigo ha letto questo dalla nostra chat',
    },
    summary: "Crea {{categories}} e {{dishes}}. Controlla ogni piatto con il suo prezzo nell'elenco qui sotto.",
    price: 'Prezzo',
    tax_category: 'Categoria fiscale',
    no_price: 'Nessun prezzo',
    default_tax: 'La tua aliquota standard',
    // Once approved: the import's run, in the words of creating a menu.
    creating: 'Creazione di {{categories}} e {{dishes}}…',
    done: 'Il menu è stato creato: {{categories}}, {{dishes}} e {{option_groups}} sono nel menu di {{restaurant}}',
    done_plain: 'Il menu è stato creato',
  },
  waiting: 'In attesa di approvazione',
  labels: {
    from: 'Da',
    to: 'A',
    menu: 'Menu',
    brings_over: 'Trasferisce',
  },
  from: {
    // "Lieferando · lieferando.de/speisekarte/pizzeria-lupo-koeln"
    platform: '{{platform}} · {{link}}',
    // "Pizzeria Lupo · 12 categories, 140 dishes"
    restaurant: '{{restaurant}} · {{categories}}, {{dishes}}',
    // "The menu Amigo read · 2 categories, 4 dishes" (B19)
    data: 'Il menu che Amigo ha letto · {{categories}}, {{dishes}}',
  },
  to: {
    only_location: '{{name}}, la sua unica sede',
    brand_one: "Menù del brand {{name}}, con un'unica sede",
    brand_other: 'Menu del brand {{name}}, tutte le {{count}} sedi',
  },
  menu: {
    empty: 'Vuoto, quindi diventa il menu',
    adds: 'Si aggiunge al menu attuale ({{size}}). I piatti con lo stesso nome vengono aggiornati; nulla viene rimosso.',
    // The menu's name and size: "Speisekarte: 12 categories, 140 dishes".
    size_named: '{{name}}: {{categories}}, {{dishes}}',
    size: '{{categories}}, {{dishes}}',
  },
  counts: {
    categories_one: '{{count}} categoria',
    categories_other: '{{count}} categorie',
    dishes_one: '{{count}} piatto',
    dishes_other: '{{count}} piatti',
    option_groups_one: '{{count}} gruppo di opzioni',
    option_groups_other: '{{count}} gruppi di opzioni',
  },
  // What an import brings over, as one list: "Categories, dishes, prices, option groups, photos, and allergens and
  // nutrition where Lieferando has them". Each item starts lowercase; the list's first letter is capitalised.
  brings_over: {
    everything: "Tutto, così com'è",
    categories: 'categorie',
    dishes: 'piatti',
    descriptions: 'descrizioni',
    prices: 'prezzi',
    option_groups: 'gruppi di opzioni',
    photos: 'foto',
    where: {
      allergens_nutrition: 'allergeni e valori nutrizionali, dove {{platform}} li ha',
      allergens: 'allergeni, dove {{platform}} li ha',
      nutrition: 'valori nutrizionali, dove {{platform}} li ha',
    },
  },
  not_live:
    '{{restaurant}} non è ancora online: gli ospiti vedono il menu sul link del negozio ma non possono ordinare.',
  buttons: {
    import: 'Importa',
    copy: 'Copia',
    cancel: 'Annulla',
  },
  hint: 'Oppure rispondi qui sotto per cambiare qualcosa.',
  action_failed: 'Non è andata a buon fine, quindi nulla è cambiato. Riprova tra un momento.',
  importing: {
    title: {
      import: 'Importazione da {{platform}}…',
      copy: 'Copia da {{restaurant}}…',
    },
    started: 'Avviata {{time}}',
    queued: 'Avvio…',
    hint: 'Può richiedere qualche minuto. Puoi chiudere il pannello o continuare a lavorare; pubblicherò qui il risultato.',
  },
  done: {
    // What is on the menu now, while the card is the only result ({{categories}} … are `counts`): "The import from
    // Lieferando is done: 12 categories, 140 dishes and 38 option groups are on Pizzeria Lupo's menu".
    title: {
      import:
        "L'importazione da {{platform}} è completata: {{categories}}, {{dishes}} e {{option_groups}} sono nel menù di {{restaurant}}",
      copy: 'La copia è completata: {{categories}}, {{dishes}} e {{option_groups}} sono nel menù',
    },
    // Without counts, or once Amigo's result under the card says them.
    title_plain: {
      import: "L'importazione da {{platform}} è completata",
      copy: 'La copia è completata',
    },
    finished: 'Terminata {{time}}',
    // The page in the sidebar's words: "Open Menu → Manage menus".
    open: 'Apri {{page}}',
  },
  failed: {
    title: {
      import: 'Impossibile importare: {{reason}}',
      copy: 'Impossibile copiare: {{reason}}',
    },
    title_plain: {
      import: 'Impossibile importare',
      copy: 'Impossibile copiare',
    },
    nothing: {
      import: 'Non è stato importato nulla.',
      copy: 'Non è stato copiato nulla.',
    },
    what_to_try: 'Cosa provare:',
    retry: 'Riprova',
    reasons: {
      listing_not_found: {
        title: 'scheda non trovata',
        text: '{{platform}} non ha nessun ristorante a questo link. Non è stato importato nulla.',
        try: 'Apri il link in un browser per verificare che mostri il menu del ristorante, poi invialo di nuovo.',
      },
      listing_not_supported: {
        title: 'scheda non supportata',
        text: 'Questa è una pagina di catena di {{platform}}, non il menu di un singolo ristorante, quindi non posso importarla. Non è stato importato nulla.',
        try: 'Invia il link alla pagina del menu del ristorante su {{platform}}.',
      },
      platform_failed: {
        title: '{{platform}} non è riuscito',
        text: '{{platform}} non ha risposto, quindi non è stato importato nulla.',
        try: 'Riprova tra qualche minuto.',
      },
      // A copy from another restaurant that failed on our side: there is no platform to name.
      copy_failed: {
        title: 'copia non riuscita',
        text: 'La copia non è stata completata, quindi non è stato copiato nulla.',
        try: 'Riprova tra qualche minuto.',
      },
      // {{listing}} and {{currency}} are currencies with their sign: "British pounds (£)", "euros (€)". {{page}} is the
      // sidebar's My info.
      currency_mismatch: {
        title: 'la valuta non corrisponde',
        text: 'La scheda è in {{listing}}, ma {{restaurant}} usa {{currency}}. Non è stato importato nulla.',
        try: 'Invia una scheda in {{currency}}, oppure controlla prima la valuta del ristorante in {{page}}.',
        text_other: 'La scheda è in una valuta diversa da quella di {{restaurant}}. Non è stato importato nulla.',
        try_other: 'Invia una scheda nella valuta del ristorante, oppure controlla prima la sua valuta in {{page}}.',
      },
      link_paused: {
        title: 'link in pausa',
        text: 'Questo link ha fallito 3 volte di fila, quindi le importazioni da esso sono in pausa fino a {{time}}. Non è stato importato nulla.',
        text_no_until:
          'Questo link ha fallito 3 volte di fila, quindi le importazioni da esso sono per ora in pausa. Non è stato importato nulla.',
        try: "Invia un link da un'altra piattaforma, oppure copia il menu da un altro ristorante.",
      },
    },
  },
  stopped: {
    title: 'Interrotto: {{restaurant}} è andato online',
    nothing: {
      import: 'Non è stato importato nulla',
      copy: 'Non è stato copiato nulla',
    },
  },
  // The card folded to one line.
  line: {
    cancelled: 'Annullato',
    expired: 'Scaduto',
    replaced: 'Sostituito',
  },
  // The message the panel sends the agent with the card's outcome (contracts §5 clientContext.changeSet).
  message: {
    approved: 'Approvato.',
    cancelled: 'Annullato.',
    retried: 'Riprovato.',
  },
};
